import { OwnershipTypeDto, TerrainDto, LossOfUseItemsDto, IndividualAcreagesDto, BankDto, LessorRepTypeDto, LessorRepresentativeDto, LessorInfoDto, LessorStakeholderDto, AddressBookDto, DamageListDto, LessorsDto, BatchDto, UomDto, QuantumDto } from '@cradua/data';
import { Observable } from 'rxjs';
import { GatewayFacade } from '../../../../../gateway/src/lib/states/+gateway/gateway.facades';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'cradua-payment-container',
  templateUrl: './payment-container.component.html',
  styleUrls: ['./payment-container.component.scss']
})
export class PaymentContainerComponent implements OnInit {
@Input() ownershiptypes: OwnershipTypeDto[];
lessors$: Observable<LessorsDto[]>;
lossofuseitems$: Observable<LossOfUseItemsDto[]>;
isLoadingownershiptype$: Observable<any>;
@Input() uoms: UomDto[];
@Input() addressbooks: AddressBookDto[];
@Input() lessorInfos: LessorInfoDto[];
@Input() lessorRepresentatives: LessorRepresentativeDto[];
@Input() lessorStakeholders: LessorStakeholderDto[];
@Input() banks: BankDto[];
@Input() lessorRepTypes: LessorRepTypeDto[];
@Input() individualAcreages: IndividualAcreagesDto[];
@Input() PaymentType: any;
@Input() quantums : QuantumDto[];
@Input() terrains: TerrainDto[];
@Input() LandTitleSerialNo: string;
itemList$ : Observable<DamageListDto[]>;
batches$: Observable<BatchDto[]>
paymentname = {firstName: '', secondName: ''}
addressBooks: AddressBookDto[];
  constructor(private gatewayFacade: GatewayFacade) { }

  ngOnInit(): void {

    if(this.PaymentType === 'Incident') {
    this.paymentname.firstName = 'Bulk payment';
    this.paymentname.secondName = 'Enumerated';
    } else {
      this.paymentname.firstName = 'Cost (Acreages)';
      this.paymentname.secondName = 'Cost (Surface Right)';
    }
    this.lossofuseitems$ =  this.gatewayFacade.loadGateway('LossOfUseItems');
    this.batches$ =  this.gatewayFacade.loadGateway('Batch');
    this.lessors$ =  this.gatewayFacade.loadGateway('Lessors');
    this.addressBooks = this.addressbooks;
  }

  searchItem(searchname: string) {
    if(searchname.length > 0) {
    this.itemList$ =  this.gatewayFacade.genericFilterGateway('DamageList', 'ItemName', searchname);
    }
  }

  selectPaymentType(type) {
    this.PaymentType = type;
  }

  searchAddressBook(searchname: string) {
    if(searchname.length > 0) {

    this.addressbooks = this.addressbooks.filter(addressBook => addressBook?.Name?.toLowerCase()?.includes(searchname?.toLowerCase()));

    } else {
      this.addressbooks = this.addressBooks;
    }
  }

  deletePayment(id) {
    this.gatewayFacade.remove('Lessors', [id]);
  }

  onSubmit(data) {
  const pullData = data.Lessors
      // console.log('activity data', pullData);

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllLessors = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllLessors.push(pullData[i]);
    }
  }

// check if the addAllLessors array is not empty, then dispatch the data to the store
   if(addAllLessors.length >  0) {
    this.gatewayFacade.add('Lessors', addAllLessors);
    // this.store.dispatch(PLStageActivityStoreActions.addPLStageActivity({newPLStageActivity: addAllPLStageActivity}));
   }

   if(allUpdates.length > 0 ) {
     // dispatch update data to the store
    this.gatewayFacade.update('Lessors', allUpdates, ['id']);
   }
   }



}
